import { HHSelect } from '@hinge-health/react-component-library';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import { PackageType, ScopeableType } from '../../../types';
import { PackageSelectionOptions } from '../../../utils/discount-utils';
import { ScopeItem } from './scope-selector-constants';

export interface PackageScopeSelectProps {
  availablePackages: PackageType[];
  disabled?: boolean;
  error?: FieldError;
}

export const PackageScopeSelect = ({
  availablePackages,
  disabled,
  error,
}: PackageScopeSelectProps): JSX.Element => {
  const { control } = useFormContext();
  const errorMessage = error?.message;

  return (
    <Controller
      control={control}
      name="scopes"
      render={({ field: { onChange, value } }): JSX.Element => {
        const scopes: ScopeItem[] = (value as ScopeItem[]) ?? [];
        const current = scopes.find(
          s => s.scopeableType === ScopeableType.Package,
        );
        const initialValue = current?.scopeableId?.toString() ?? '';

        return (
          <HHSelect
            width={'100%'}
            label="Package"
            id="package-scope-select"
            data-testid="package-scope-select"
            disabled={disabled ?? false}
            initialSelectValue={initialValue}
            selectOptions={PackageSelectionOptions(availablePackages)}
            inputProps={{ 'aria-required': true }}
            error={!!errorMessage}
            helperText={errorMessage}
            fullWidth
            onChange={(e): void => {
              const raw = (e.target as HTMLInputElement).value;
              const id = parseInt(raw, 10);
              onChange(
                Number.isNaN(id)
                  ? []
                  : [
                      {
                        scopeableType: ScopeableType.Package,
                        scopeableId: id,
                      } as ScopeItem,
                    ],
              );
            }}
          />
        );
      }}
    />
  );
};
